import { render, staticRenderFns } from "./RegisterOk.vue?vue&type=template&id=20815a03&scoped=true&"
import script from "./RegisterOk.vue?vue&type=script&lang=js&"
export * from "./RegisterOk.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOk.vue?vue&type=style&index=0&id=20815a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20815a03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20815a03')) {
      api.createRecord('20815a03', component.options)
    } else {
      api.reload('20815a03', component.options)
    }
    module.hot.accept("./RegisterOk.vue?vue&type=template&id=20815a03&scoped=true&", function () {
      api.rerender('20815a03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RegisterOk.vue"
export default component.exports